import classNames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var BreadCrumbs = function BreadCrumbs(_ref) {
  var breadCrumbs = _ref.breadCrumbs;
  var router = useRouter();

  var navigateBack = function navigateBack(event) {
    event.preventDefault();
    router.back();
  };

  var renderBreadCrumbs = function renderBreadCrumbs() {
    return breadCrumbs.map(function (bc, index) {
      var showCaret = !!index;
      var marginClass = showCaret ? 'ml-4 ' : '';
      return /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex items-center",
          children: [showCaret && /*#__PURE__*/_jsx("svg", {
            className: "flex-shrink-0 h-5 w-5 text-gray-400",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 20 20",
            fill: "currentColor",
            "aria-hidden": "true",
            children: /*#__PURE__*/_jsx("path", {
              fillRule: "evenodd",
              d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
              clipRule: "evenodd"
            })
          }), /*#__PURE__*/_jsx(Link, {
            href: bc.url,
            children: /*#__PURE__*/_jsx("a", {
              className: "".concat(marginClass, " text-base font-medium text-gray-500 hover:text-gray-700"),
              children: bc.name
            })
          })]
        })
      }, bc.url);
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("nav", {
      className: classNames('sm:hidden', {
        invisible: breadCrumbs.length <= 1
      }),
      "aria-label": "Back",
      children: /*#__PURE__*/_jsxs("span", {
        onClick: navigateBack,
        className: "flex items-center text-base font-medium text-gray-500 hover:text-gray-700 cursor-pointer",
        children: [/*#__PURE__*/_jsx("svg", {
          className: "flex-shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-400",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 20 20",
          fill: "currentColor",
          "aria-hidden": "true",
          children: /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
            clipRule: "evenodd"
          })
        }), "Back"]
      })
    }), /*#__PURE__*/_jsx("nav", {
      className: "hidden sm:flex",
      "aria-label": "Breadcrumb",
      children: /*#__PURE__*/_jsx("ol", {
        className: "flex items-center space-x-4 list-none p-0 m-0",
        children: renderBreadCrumbs()
      })
    })]
  });
};
BreadCrumbs.defaultProps = {};